/* eslint-disable no-undef */
import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';
import { getProcessUrls } from '../api/apiConstants';
import { createBrowserHistory } from 'history'
export const browserHistory = createBrowserHistory();


export const formatName = (string) => startCase(toLower(string));
const appHeader = {
    // 'Authorization': "Basic",
    "Content-Type": "application/json",
    'Accept': "application/json",
};

export const getData = async (url, headers) => {
    let result = await fetch(url, {
        method: 'GET',
        headers: { ...appHeader, ...headers }

    });

    return result;
}


export const postData = async (url, data, headers = {}) => {

    let result = await fetch(url, {
        method: 'POST',
        headers: { ...appHeader, ...headers },
        body: JSON.stringify(data).replace(/\s(?=\w+":)/g, "")// JSON.stringify(data)
    });
    return result;
}


export const putData = async (url, data) => {

    let result = await fetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    return result;
}


export const initHostedSession = (handleSubmit, validateForm) => {
    // paymentAuthentication.form = "#spa-payment-form";
    // paymentAuthentication.cardStringType = { id: 'cardStringType', name: 'cardStringType' };
    // paymentAuthentication.fundsType = { id: 'fund-type', name: 'fundType' };
    // paymentAuthentication.maskedCardNumber = { id: 'maskedCardNumber', name: 'maskedCardNumber' };
    // paymentAuthentication.cardType = null;
    // paymentAuthentication.cardExpYear = null;
    // paymentAuthentication.cardExpMonth = null;
    // paymentAuthentication.cardNumber = {
    //     id: "cardNumber",
    //     name: "CardNumber"
    // };
    // paymentAuthentication.CVV = 
    //     {
    //         id: "securityCode",
    //         name: "CardCode"
    //     };
    // paymentAuthentication.init('dev1', false);
    let cardFields = [];
    cardFields.push({
        cardNumber: {
            'id': 'cardNumber',
            'name': 'CardNumber',
            'label': 'Credit Card Number'
        },
        securityCode: {
            'id': 'securityCode',
            'name': 'CardCode',
            'label': 'Security Code'
		},
		expiryYear: {
			'id': 'year',
			'name': 'expYear',
			'label': 'Expiration Year'
		},
		expiryMonth: {
			'id': 'month',
			'name': 'expMonth',
			'label': 'Expiration Month'
		},
		cardType: {
			'id':'cardType',
            'name':'mcBrand'
		},
        maskedCardNumber:{
            'id':'maskedCardNumber',
            'name':'maskedCardNumber'
        },
        cardStringType: {
            id: 'cardStringType',
            name: 'cardStringType'
        },
        fundsType: {
            id: 'fund-type',
            name: 'fundType'
        }
    });

    let NODE_ENV = getProcessUrls['NODE_ENV'];
    let pay_ENV = (NODE_ENV === 'production') ? 'prod' : 'dev1';

    paymentAuth.init({
        env: pay_ENV, //'stage','prd'
        form: "spa-payment-form",
        cardFields: cardFields,
        threeDSPaymentData: null,
        submitForm: handleSubmit,
        validateForm: validateForm,
        // submitForm: payment.submitForm.bind(payment),
		  afterSessionInit: hidePaymentFieldLoading(),
		  clickjackHandler: () => {
			  // NOTE: this is is a dummy method to prevent pcl-payment-auth.js from defaulting to standard CJ solution. script on index will handle this from the start.
		  },
        errorContainer: 'spa-mcErrorContainer'
        // before3DSRedirect: payment.submit3DSForm.bind(payment),
    });
}

const hidePaymentFieldLoading = () => {
    console.log('Hosted session initiated');
}

export const getNavHeaderData = async (url, authToken) => {
    let result = await fetch(url, {
        withCredentials: true,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'ProductCompany': 'PC',
            'BookingCompany': 'PC',
            'AuthToken': authToken,
            'AppId': '{"agencyId":"DIRPB","cruiseLineCode":"PCL","sessionId":"Unique Token","systemId":"PB"}'
        }
    });
    return result;
}